// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-b7bd429c]::-webkit-outer-spin-button,\ninput[data-v-b7bd429c]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-b7bd429c] {\n  -moz-appearance: textfield;\n}\n[data-v-b7bd429c] .core-tooltip__popper {\n  background-color: white !important;\n}", ""]);
// Exports
module.exports = exports;
